module.exports = __webpack_public_path__ + "static/media/vilnius-9.52446147.jpg";